import { combineReducers } from "redux";
import authReducer from "./auth/slice";

export const createRootReducer = (injectReducers: Record<string, any> = {}) => {
  return combineReducers({
    auth: authReducer,
    ...injectReducers,
  });
};
